import { Component, Input, Output, EventEmitter } from "@angular/core";

import {
  User,
  Invite,
  InviteListConfig,
} from "../../../../../../shared/models";
import { InviteService, UserService } from "../../../../../shared/../services";

/*
  config.type are either sent or received
  targetModel is either Community or Discussion
  sender or recipient can also be specified                    
*/

@Component({
  selector: "invite-card-list",
  templateUrl: "./invite-card-list.component.html",
  styleUrls: [
    "./invite-card-list.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class InviteCardListComponent {
  public currentUser: User;
  private query: InviteListConfig;
  public results: Invite[];
  public loading: boolean = false;
  public currentPage: number = 1;
  public totalPages: number = 1;

  @Output() fetchInviteUsers = new EventEmitter<any>();
  @Input() limit: number;
  @Input()
  set config(config: InviteListConfig) {
    if (config) {
      this.query = config;
      this.currentPage = 1;
      this.runQuery();
    }
  }

  constructor(
    private inviteService: InviteService,
    private userService: UserService
  ) {
    this.userService.currentUser.subscribe((userData: User) => {
      this.currentUser = userData;
    });
  }

  public updateLoading(status: boolean) {
    this.loading = status;
  }

  public updateInvites(inviteObj) {
    const inviteIndex = this.results.findIndex(
      (invite) => invite.id === inviteObj.inviteId
    );
    this.results[inviteIndex].status = inviteObj.status;
  }

  public sendInviteUsers(invites: Invite[]) {
    var users;
    if (this.query.type === "received") {
      users = invites.map((invite) => invite.sender);
    }
    if (this.query.type === "sent") {
      users = invites.map((invite) => invite.recipient);
    }

    // fetch only unique values
    const keyValueArray = users.map((entry) => [entry["username"], entry]);
    const map = new Map(keyValueArray);
    const uniqueArray = Array.from(map.values());
    this.fetchInviteUsers.emit(uniqueArray);
  }

  public fetchUserInvites() {
    this.inviteService
      .findMany(this.currentUser.username, this.query)
      .subscribe((data) => {
        this.results = data.invites;
        this.totalPages = data.pages.total;
        this.sendInviteUsers(data.invites);
        this.loading = false;
      });
  }

  public runQuery() {
    this.loading = true;
    this.results = [];

    if (this.limit) {
      this.query.limit = this.limit;
      this.query.offset = this.limit * (this.currentPage - 1);
    }

    this.fetchUserInvites();
    window.scroll(0, 0);
  }

  public setPageTo(pageNumber: number) {
    this.currentPage = pageNumber;
    this.runQuery();
  }
}
